import { createSlice } from "@reduxjs/toolkit";

import { getDetailedAuditTrial } from "../../api/postCall/getDetailedAuditTrial";
import { DetailedEventModel } from "../../data-model/eventsModal";

interface AuditTrialState {
  data?: DetailedEventModel;
  isLoading: boolean;
  error: string | undefined;
}

const initialState: AuditTrialState = {
  data: undefined,
  isLoading: false,
  error: undefined,
};

export const auditTrialSlice = createSlice({
  name: "auditTrial",
  initialState: initialState,
  reducers: {
    setAuditTrialDetails: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = undefined;
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.error = undefined;
      state.data = undefined;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.data = undefined;
    },
    resetAuditTrial: (state) => {
      state.data = undefined;
      state.isLoading = false;
      state.error = undefined;
    },
  },
});

export const getAuditTrialDetails =
  (orderId: string, name: string, tag: string) =>
  async (dispatch, getState) => {
    const state = getState();
    if (state.auditTrial.isLoading) return;

    dispatch(setIsLoading());
    try {
      const response = await getDetailedAuditTrial({
        order_id: orderId,
        name: name,
        tag: tag,
      });

      dispatch(setAuditTrialDetails(response));
    } catch (error) {
      dispatch(setError(error as Error));
    }
  };
export const { setAuditTrialDetails, setIsLoading, setError, resetAuditTrial } =
  auditTrialSlice.actions;
export default auditTrialSlice.reducer;
